import { render, staticRenderFns } from "./Experimental.vue?vue&type=template&id=7da95c28&"
import script from "./Experimental.vue?vue&type=script&lang=js&"
export * from "./Experimental.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7da95c28')) {
      api.createRecord('7da95c28', component.options)
    } else {
      api.reload('7da95c28', component.options)
    }
    module.hot.accept("./Experimental.vue?vue&type=template&id=7da95c28&", function () {
      api.rerender('7da95c28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/configuration/Experimental.vue"
export default component.exports